export const IntroSection = () => {
  return (
    <section className="py-20 bg-white" data-testid="intro-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="glass-card p-8 md:p-12 rounded-2xl text-center">
          <div className="inline-block mb-6">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mx-auto"></div>
          </div>
          
          <h2
            className="text-3xl md:text-4xl font-bold mb-6"
            style={{ color: 'var(--navy-900)' }}
          >
            Spezialisiert auf Handelsimmobilien
          </h2>
          
          <div className="max-w-3xl mx-auto space-y-4 text-lg leading-relaxed" style={{ color: 'var(--gray-700)' }}>
            <p>
              <strong style={{ color: 'var(--navy-800)' }}>RetailInvest</strong> ist eine Marke von{' '}
              <strong style={{ color: 'var(--navy-800)' }}>Heinrichs Immobilien</strong> und fokussiert
              sich ausschließlich auf den Verkauf von Handelsimmobilien. 
            </p>
            <p>
              Mit unserem strukturierten Prozess und tiefem Marktverständnis unterstützen wir Eigentümer dabei, 
              den richtigen Käufer zu finden und beste Konditionen zu erzielen.
            </p>
            <p className="text-base pt-4" style={{ color: 'var(--gold-600)' }}>
              <strong>Unser Ansatz:</strong> Ehrlich, transparent und fokussiert auf Ihre Ziele.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};